import { useState } from 'react';
import { Popover, PopoverPanel, Transition } from '@headlessui/react';
import { usePopper } from 'react-popper';
import Icon from '@/core/icon';
import { useTranslation, Markdown } from '@/helpers/translate';

function Label({ title, description, icon }) {
  const { t } = useTranslation();
  const [refLabel, setRefLabel] = useState();
  const [refPopover, setRefPopover] = useState();
  const [open, setOpen] = useState(false);
  const { attributes } = usePopper(refLabel, refPopover);

  return (
    <Popover onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <span ref={setRefLabel}><Icon name={icon} className="text-purple size-7" /></span>
      <Transition
        as="div"
        className="relative z-30 top-2"
        show={open}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <PopoverPanel
          static
          className="absolute flex flex-col px-4 py-3 my-2 mb-2 text-sm text-white bg-black rounded-lg w-60 shadow-button"
          ref={setRefPopover}
          {...attributes.popper}
        >
          <div className="flex flex-col">
            <span className="text-sm font-medium leading-tight text-white">{t(title)}</span>
            <Markdown className="mt-1 text-sm leading-5 text-dark-light">{t(description)}</Markdown>
          </div>
        </PopoverPanel>
      </Transition>
    </Popover>
  );
}

export default Label;
